import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faThumbsDown,faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { MembershipService } from 'app/core/services/membership.service';
import { SurveyMetaModel, SurveyQuestionResponseModel } from 'app/core/models/survey-question-response.model';
import { SurveyResponseService } from 'app/core/services/survey-response.service';
@Component({
    selector: 'app-survey-question',
    templateUrl: './survey-question.component.html',
    styleUrls: ['./survey-question.component.scss'],
    standalone: false
})
export class SurveyQuestionComponent extends NexusComponent implements OnInit {
  @Input() survey_question_id: string;
  @Input() survey_question_text: string;
  @Input() survey_meta: Array<SurveyMetaModel>;
  @Input() is_invoice_page=false;
  public feedback_text: string;
  public faThumbsDown = faThumbsDown;
  public faThumbsUp = faThumbsUp;
  public show_feedback = true;
  public thank_feedback = true;
  public like_dislike_feedback = true;
  public survey_question_response_model =  new SurveyQuestionResponseModel();

  constructor(private route: ActivatedRoute, private survey_response_service: SurveyResponseService, private membership: MembershipService) {
    super();
}
  ngOnInit(): void {
    this.survey_question_response_model.survey_questionId = this.survey_question_id;
    this.survey_question_response_model.survey_meta = this.survey_meta;
    this.set_like_dislike_feedback();
    console.log(this.survey_question_response_model);

  }

  set_show_feedback(){
    this.show_feedback = true;
    this.thank_feedback= false;
    this.like_dislike_feedback =false;
  }
  set_thank_feedback(){
    this.show_feedback = false;
    this.thank_feedback= true;
    this.like_dislike_feedback =false;
  }
  set_like_dislike_feedback(){
    this.show_feedback = false;
    this.thank_feedback= false;
    this.like_dislike_feedback =true;
  }
  thumb_click(value: boolean){
    this.survey_question_response_model.thumbs_up_down = value;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.set_show_feedback();});
  }
  submit_click(){
    this.survey_question_response_model.feedback_text = this.feedback_text;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.set_thank_feedback();});
  }
  dismiss_click(){
    this.survey_question_response_model.dismissed = true;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.set_thank_feedback();});
  }

  update_survey_question_response(payload: SurveyQuestionResponseModel,call_back: Function) {
    this.StartSpinner();
    this.survey_response_service.PutSurveyResponse(payload).subscribe(
        data => {
            payload.id = data.id;
            this.StopSpinner();
            if(call_back!= null){
              call_back();
            }

        },
        err => {
            this.StopSpinner();
            if(call_back!= null){
              call_back();
            }
        });
}

}
